module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAA00lEQVQ4jaXTPUoEQRAF4M+f1DuICJoKIngCU1HwHJPtnkO8gJkeQtlwwcxoAwUPYGCwYOS+ZaCRoV1hdragoKp43a/qVbckTZLv9LcW22y1AX7wpp8dYkfhmSTR01tstnuy/LHdqrCPG9ziAielHtzj4xdZtTou+XmSWSXXOJ1Wa8Y7vGCKSxyX+gLPXWB9cI6nEs+Kr7RanCu84wAP+Cr+iesucLCqg/dYz7iHU0xwtEKc+X+Mo5KfrbuOx3L7K0bVA2jF2nzGwapu9K3W/8hJswSiBoGARpMg6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/zdmx.png
// module id = 5MM8
// module chunks = 1